import React from "react";

export default function HealthLevel(props) {

  const indicator = props.indicator;

  if (!indicator.is_active) {
    return <td className="health-indicator-status">
      <span className="health-level health-level-disabled">
        <i className="bx bx-info-circle" title="Indicator is disabled on this cluster."/> Disabled
      </span>
    </td>
  }

  switch (indicator.level) {
    case "GREEN":
      return <td className="health-indicator-status">
        <span className="health-level health-level-green">
          <i className="bx bx-check-circle" title="Indicator is healthy."/> Healthy
        </span>
      </td>;
    case "ORANGE":
      return <td className="health-indicator-status">
        <span className="health-level health-level-orange">
          <i className="bx bx-error" title="Indicator is in WARNED state."/> Warning
        </span>
      </td>;
    case "RED":
      return <td className="health-indicator-status">
        <span className="health-level health-level-red">
          <i className="bx bx-error" title="Indicator is in ERROR state."/> Error / Critical
        </span>
      </td>;
  }

}
